<template>
    <div class="file-lists">
        <div class="btns" flex="main:justify" style="margin-bottom: 20px;">
            <el-button-group size="mini">
                <el-button size="mini" :type="formSearch.type == 'image' ? 'primary' : 'default'" @click="changeType('image')">图片</el-button>
                <el-button size="mini" :type="formSearch.type == 'video' ? 'primary' : 'default'" @click="changeType('video')">视频</el-button>
            </el-button-group>
            <el-button-group size="mini">
                <el-upload
                    :action="action"
                    style="display: inline-block"
                    :headers="headers"
                    :data="{}"
                    multiple
                    name="upload"
                    :show-file-list="false"
                    :on-success="fileSuccess"
                    :before-upload="beforeUpload">
                    <el-button size="small">上传图片</el-button>
                </el-upload>
                <el-upload
                    :action="actionVideo"
                    style="display: inline-block"
                    :headers="headers"
                    :data="{}"
                    name="upload"
                    :show-file-list="false"
                    :on-success="fileSuccess"
                    :before-upload="beforeUpload">
                    <el-button size="small">上传视频</el-button>
                </el-upload>
            </el-button-group>
        </div>
        <div class="lists" flex="" v-if="tableData.length > 0">
            <div class="item" :class="{video: formSearch.type == 'video'}" v-for="(c,i) in tableData" :key="i">
                <div class="image" flex="main:center cross:center">
                    <CImage v-if="formSearch.type == 'image'" :url="c.url"></CImage>
                    <video controls v-else-if="formSearch.type == 'video'" :src="$util.img(c.url)"></video>
                    <el-tooltip effect="dark" :content="c.name" placement="top">
                        <div class="name f12">{{c.name}}</div>
                    </el-tooltip>
                </div>
                <div class="size text-gray" flex="main:center">
                    <span class="f12">大小：</span>
                    <FileSize :size="c.size"></FileSize>
                </div>
                <div class="btn">
                    <a href="javascript:;" class="btn-a f12" @click="selectFile(c)">{{inserts.indexOf(c.id) >= 0 ? '已' : '' }}选择</a>
                </div>
            </div>
        </div>
        <div v-else>
            <el-empty></el-empty>
        </div>

		<div style="margin-top: 20px; margin-bottom: 20px;">
			<el-pagination background layout="total, prev, pager, next" :page-size="15" :current-page.sync="currentPage" @current-change="pageChange" :total="total"></el-pagination>
		</div>

    </div>
</template>

<script>
    export default {
        data(){
            return {
                formSearch: {
                    type: 'image',
                },
                tableData: [],
                currentPage: 1,
                total: 0,
                action: '',
                actionVideo: '',
                headers: {},
                inserts: [],
            }
        },
        mounted(){
            this.init()
        },
        methods: {
            async init(){
                this.inserts = []
                this.action = this.$config.baseUrl + '/api/school/file/upload/image';
                this.actionVideo = this.$config.baseUrl + '/api/school/file/upload/video';
                this.headers = {'Authorization': this.$util.cacheGet("authTokenSchool")};
                this.getLists();
            },	
            pageChange(page){
                this.getLists(page)
            },
            changeType(type){
                this.formSearch.type = type;
                this.getLists(1);
            },
             fileSuccess(res, file) {
                 if(res.status == 0){
                     return this.$message({
                         message: res.msg,
                         type: 'error'
                     })
                 }
                 this.getLists()
            },
            beforeUpload(file){
                if(file.size > (200 * 1024 * 1024)){
                    this.$message({
                        message: '文件大小不超过200M',
                        type: 'error'
                    })
                    return false
                }
            },
            async getLists(page){
                this.tableLoading = true;
                let res = await this.$api.rGet('file', {
                    page: page ? page: 1,
                    pageSize: 10,
                    type: this.formSearch.type ? this.formSearch.type : ''
                });
                this.tableLoading = false;
                if(res.status == 1){
                    this.tableData = res.data.data;
                    this.currentPage = res.data.current_page;
                    this.total = res.data.total;
                }
            },
            selectFile(row){
                this.inserts.push(row.id)
                this.$emit('success', row);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .lists{
        flex-wrap: wrap;
    }
    .item{
        width: 100px;
        height: 140px;
        margin-right: 20px;
        margin-bottom: 20px;
        .image{
            width: 100px;
            height: 100px;
            border: 1px solid #aaa;
            box-sizing: border-box;
            padding: 5px;
            position: relative;
            .img{
                max-width: 90px;
                max-height: 90px;
            }
            .name{
                position: absolute;
                left: 0;
                bottom: 0;
                background: rgba(0,0,0,0.6);
                width: 100%;
                color: #fff;
                height: 20px;
                line-height: 20px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: center;
                cursor: pointer;
            }
        }
        .size{
            height: 20px;
            line-height: 20px;
        }
        .btn{
            height: 20px;
            line-height: 20px;
            text-align: center;
        }

        &.video{
            width: 200px;
            height: 240px;
            .image{
                width: 200px;
                height: 200px;
            }
            video{
                width: 200px;
                height: 180px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/FileList.vue